/*
 * lf-product-callout.js
 * Progressive Enhancement für sections/lf-product-callout.liquid:
 * AJAX-Add-to-Cart (inkl. Pfand-Zeile aus dem Formular), Rabattcode anwenden,
 * Cart Drawer über cart-drawer.renderContents() aktualisieren und öffnen.
 */
if (!customElements.get('lf-product-callout')) {
  customElements.define(
    'lf-product-callout',
    class LfProductCallout extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.submit = this.querySelector('[data-lpc-submit]');
        this.error = this.querySelector('[data-lpc-error]');
        this.code = (this.dataset.discountCode || '').trim();
        if (!this.form || !this.submit) return;

        this.onSubmit = this.onSubmit.bind(this);
        this.form.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      }

      itemsFromForm() {
        const data = new FormData(this.form);
        const items = [];
        for (const [key, value] of data.entries()) {
          const match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$|^items\[(\d+)\]\[properties\]\[(.+)\]$/);
          if (!match) continue;
          const index = Number(match[1] || match[3]);
          items[index] = items[index] || {};
          if (match[2]) items[index][match[2]] = Number(value);
          else (items[index].properties = items[index].properties || {})[match[4]] = value;
        }
        return items.filter(Boolean);
      }

      async onSubmit(event) {
        event.preventDefault();
        if (this.submit.disabled) return;
        this.setBusy(true);
        this.error.textContent = '';

        try {
          const response = await fetch(this.dataset.cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: this.itemsFromForm() }),
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'Das hat leider nicht geklappt.');
          }

          await this.applyDiscount();
          await this.refreshCart();
          this.setBusy(false);
        } catch (e) {
          this.error.textContent =
            e && e.message && e.message !== 'Failed to fetch'
              ? e.message
              : 'Keine Verbindung. Bitte versuche es noch einmal.';
          this.setBusy(false);
        }
      }

      // Code ergänzen, ohne bestehende Codes im Warenkorb zu überschreiben.
      // Fallback: /discount/<Code> setzt das Discount-Cookie für den Checkout.
      async applyDiscount() {
        if (!this.code) return;
        const wanted = this.code.toLowerCase();
        try {
          const cart = await fetch(this.dataset.cartUrl + '.js').then((r) => r.json());
          const codes = (cart.discount_codes || []).map((d) => d.code);
          if (codes.some((c) => c.toLowerCase() === wanted)) return;

          const updated = await fetch(this.dataset.cartUpdateUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.concat(this.code).join(',') }),
          }).then((r) => r.json());

          const applied = (updated.discount_codes || []).some(
            (d) => d.code.toLowerCase() === wanted && d.applicable
          );
          if (applied) return;
        } catch (e) {
          // weiter mit dem Fallback
        }
        await fetch('/discount/' + encodeURIComponent(this.code), { credentials: 'same-origin' }).catch(() => {});
      }

      // Wie product-form.js: Drawer und Warenkorb-Icon neu rendern, "is-empty" am <cart-drawer>
      // selbst entfernen (renderContents() setzt es nur am inneren Container), rerenderCart feuern.
      async refreshCart() {
        const drawer = document.querySelector('cart-drawer');
        try {
          const root = this.dataset.rootUrl.replace(/\/$/, '');
          const sections = await fetch(root + '/?sections=cart-drawer,cart-icon-bubble').then((r) => r.json());
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents({ sections: sections });
          } else {
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble && sections['cart-icon-bubble']) {
              const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
              const inner = html.querySelector('.shopify-section');
              if (inner) bubble.innerHTML = inner.innerHTML;
            }
          }
          document.dispatchEvent(new CustomEvent('rerenderCart'));
        } catch (e) {
          // Warenkorb ist befüllt, nur die Anzeige konnte nicht aktualisiert werden.
        }
      }

      setBusy(busy) {
        this.submit.disabled = busy;
        this.submit.setAttribute('aria-busy', busy ? 'true' : 'false');
      }
    }
  );
}
